/**
 * Artifact Plugins Index
 * 
 * This file exports the plugin registry and registers all available plugins.
 * Import this file in your app initialization to auto-register all plugins.
 */

import { ArtifactPluginRegistry } from './ArtifactPluginRegistry'
import { KycArtifactPlugin } from './KycArtifactPlugin'
import { DataArtifactPlugin } from './DataArtifactPlugin'

// Export the registry and types
export { ArtifactPluginRegistry } from './ArtifactPluginRegistry'
export type { ArtifactPluginProps, ArtifactPluginComponent } from './ArtifactPluginRegistry'

// Artifact type IDs (from legacy blockchain integration)
const KYC_ARTIFACT_TYPE_ID = 'b2c3d4e5-f6a1-4b2c-9d8e-000000000002'
const DATA_ARTIFACT_TYPE_ID = 'b2c3d4e5-f6a1-4b2c-9d8e-000000000003'

// Register all plugins
ArtifactPluginRegistry.register({
  artifactTypeId: KYC_ARTIFACT_TYPE_ID,
  component: KycArtifactPlugin,
  name: 'KYC Verification',
  description: 'Enhanced viewer for KYC verification artifacts with encrypted image support'
})

ArtifactPluginRegistry.register({
  artifactTypeId: DATA_ARTIFACT_TYPE_ID,
  component: DataArtifactPlugin,
  name: 'Data Transaction',
  description: 'Enhanced viewer for DATA transactions with JSON detection and base64 decoding'
})

// Log registered plugins
console.log(`Registered ${ArtifactPluginRegistry.getAllPlugins().length} artifact plugin(s)`)
